<div [formGroup]="contactForm">
  <div class="mb-1 flex items-center justify-between">
    <h3 class="typo-h6-semibold text-text-primary">{{ 'health_history_patient_secondary_contacts' | translate }}</h3>
    <svg-icon
      [key]="isEditMode() ? 'px-16-x' : 'px-16-edit'"
      (click)="isEditMode() ? cancel() : onEditClick()"
      class="cursor-pointer text-primary-blue"
      size="sx"
    ></svg-icon>
  </div>

  <lib-health-history-contact-row
    [title]="'health_history_patient_secondary_emergency_contact' | translate"
    [namePlaceholder]="'health_history_patient_secondary_contact_name' | translate"
    [phonePlaceholder]="'health_history_patient_secondary_contact_phone' | translate"
    [isEditMode]="isEditMode()"
    [validationErrors]="contactForm.controls.emergency.errors"
    formControlName="emergency"
  ></lib-health-history-contact-row>

  <lib-health-history-contact-row
    [title]="'health_history_patient_secondary_pharmacy' | translate"
    [namePlaceholder]="'health_history_patient_secondary_contact_name' | translate"
    [phonePlaceholder]="'health_history_patient_secondary_contact_phone' | translate"
    [isEditMode]="isEditMode()"
    [validationErrors]="contactForm.controls.pharmacy.errors"
    formControlName="pharmacy"
  ></lib-health-history-contact-row>

  <lib-health-history-contact-row
    [title]="'health_history_patient_secondary_physician' | translate"
    [namePlaceholder]="'health_history_patient_secondary_contact_name' | translate"
    [phonePlaceholder]="'health_history_patient_secondary_contact_phone' | translate"
    [isEditMode]="isEditMode()"
    [validationErrors]="contactForm.controls.physician.errors"
    formControlName="physician"
  ></lib-health-history-contact-row>

  @if (isEditMode()) {
    <div class="mt-3 flex justify-end gap-2">
      <button class="btn-secondary px-5" (click)="cancel()">
        {{ 'health_history_patient_secondary_contacts_cancel' | translate }}
      </button>
      <button class="btn-primary px-5" (click)="saveContactDetails()" [disabled]="!contactForm.valid">
        <svg-icon key="px-24-save" size="md"></svg-icon>{{ 'health_history_patient_secondary_contacts_save' | translate }}
      </button>
    </div>
  }
</div>
